import { useTranslations } from 'next-intl';
import { getDisplayValues } from '@mentimeter/visualizations-react/utils/get-display-values';

interface ScreenReaderResultsProps {
  results: { [id: number]: number };
  rangeMin: number;
  rangeMax: number;
  responseRangeScale: number;
  shouldHideResults: boolean;
}

export const ScreenReaderResults = ({
  results,
  rangeMin,
  rangeMax,
  responseRangeScale,
  shouldHideResults,
}: ScreenReaderResultsProps) => {
  const translate = useTranslations('presenting.screenreader_table');

  if (shouldHideResults) {
    return <span>{translate('results_are_hidden_message')}</span>;
  }

  const displayValues = getDisplayValues(
    rangeMin,
    rangeMax,
    responseRangeScale,
  );

  return (
    <table>
      <caption>{translate('results_table_caption')}</caption>
      <thead>
        <tr>
          <th scope="col">{translate('number_column_title')}</th>
          <th scope="col">{translate('number_of_guesses_column_title')}</th>
        </tr>
      </thead>
      <tbody>
        {displayValues.map((numberValue, i) => {
          const score = results[i];

          if (!score) {
            return null;
          }

          return (
            <tr key={numberValue}>
              <th scope="row">{numberValue}</th>
              <td>{score}</td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};
